import { EventAggregator } from 'aurelia-event-aggregator';

export default {
  name: 'eventAggregator',
  fn: EventAggregator
};